import { Lock } from '@material-ui/icons';

type ActionContent = {
  signLabel: string;
  otherCaseInGroupSubmittingLabel: string;
};

export const ButtonContentForIdleStatus = ({
  isRecording,
  isOtherCaseInGroupSubmitting = false,
  isBypass = false,
  content = {
    signLabel: 'Sign',
    otherCaseInGroupSubmittingLabel: 'Signing With Group',
  },
}: {
  isRecording: boolean;
  isOtherCaseInGroupSubmitting?: boolean;
  isBypass?: boolean;
  content?: ActionContent;
}): React.ReactElement => {
  if (isRecording) {
    return <>Recording...</>;
  }
  if (isOtherCaseInGroupSubmitting) {
    return (
      <>
        <Lock
          css={`
            margin-right: 0.5rem;
            margin-left: -1rem;
          `}
        />
        {content.otherCaseInGroupSubmittingLabel}
      </>
    );
  }
  return (
    <>
      {isBypass ? 'Bypass and ' : ''}
      {content.signLabel}
    </>
  );
};
